<template>
  <v-row no-gutters>
    <feature-card-basic ref="featureCard" @update:feature="getVideoUrl" :layer="layer">
      <template #top v-if="videoVisible">
        <sidebar-row class="mt-5 pr-8">
          <video-player :src="videoUrl" type="video/mp4" />
          <v-divider class="mt-5" />
        </sidebar-row>
      </template>
      <main-loader v-else class="pt-10" />
    </feature-card-basic>
  </v-row>
</template>

<script>
import { get } from 'vuex-pathify';

import FeatureCardBasic from '@/components/FeatureCardBasic';
import SidebarRow from '@/components/SidebarRow';
import MainLoader from '@/components/MainLoader';

export default {
  name: 'FeatureCardVideo',
  components: {
    FeatureCardBasic,
    SidebarRow,
    MainLoader,
    VideoPlayer: () => import('@/components/VideoPlayer'),
  },
  props: {
    layer: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    videoUrl: '',
  }),
  computed: {
    isSuperAdminEnabled: get('admin/additionalModules@VIDEO_MODULE.enabled'),
    isAdminEnabled: get('admin/settingsValues@video_module_enabled'),
    modulesPermission: get('users/toolsPermissions@VIDEO_MODULE.main_value'),
    videoSelectedUrlAttribute: get('admin/modulesMapping@video.selected_uri_column'),
    currentFeatureId() {
      return this.$route.params.fid;
    },
    isNew() {
      return this.currentFeatureId === 'new';
    },
    videoVisible() {
      return this.isSuperAdminEnabled && this.isAdminEnabled && !this.isNew && this.modulesPermission && this.videoUrl;
    },
  },
  watch: {
    currentFeatureId: {
      immediate: true,
      handler(nV) {
        if (nV || nV === 0) {
          this.getVideoUrl();
        }
      },
    },
  },
  methods: {
    getVideoUrl(feature) {
      if (feature?.properties[this.videoSelectedUrlAttribute]) {
        this.videoUrl = feature.properties[this.videoSelectedUrlAttribute] + '/download';
      } else {
        this.videoUrl = '';
      }
    },
  },
};
</script>
